import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box02_PatientName: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">
        2. PATIENT&apos;S NAME (Last Name, First Name, Middle Initial)
      </Typography>
      <Box display="flex" gap={1}>
        <Controller
          name="patientName.lastName"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Last"
              sx={{ flex: '1 1 40%' }}
            />
          )}
        />
        <Controller
          name="patientName.firstName"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="First"
              sx={{ flex: '1 1 40%' }}
            />
          )}
        />
        <Controller
          name="patientName.middleInitial"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="MI"
              inputProps={{ maxLength: 1 }}
              sx={{
                flex: '0 0 80px',
                maxWidth: '80px',
              }}
            />
          )}
        />
      </Box>
    </>
  );
};